<template>
  <div class="system-dic-container layout-padding">
    <el-card shadow="hover" class="layout-padding-auto">
      <div class="system-user-search mb15">
        <el-input
          v-model="queryData.SearchValue"
          size="small"
          placeholder="请输入"
          style="max-width: 180px"
        >
        </el-input>
        <el-button
          size="small"
          type="primary"
          class="ml10"
          @click="queryTableData"
        >
          <el-icon>
            <ele-Search />
          </el-icon>
          查询
        </el-button>
        <!-- <el-button
          size="small"
          type="success"
          class="ml10"
          @click="onOpenAddDic({})"
        >
          <el-icon>
            <ele-FolderAdd />
          </el-icon>
          新增
        </el-button> -->
      </div>
      <el-table :data="tableData" v-loading="loading" style="width: 100%">
        <el-table-column type="index" label="序号" width="50" />
        <el-table-column
          prop="TempName"
          label="活动名称"
          width="200"
          show-overflow-tooltip
        ></el-table-column>
        <el-table-column
          prop="Venue"
          label="主办单位"
          width="160"
          show-overflow-tooltip
        ></el-table-column>
        <el-table-column
          prop="ActivityName"
          label="姓名"
          width="160"
          show-overflow-tooltip
        ></el-table-column>
        <el-table-column
          prop="Phone"
          label="电话"
          show-overflow-tooltip
        ></el-table-column>
        <el-table-column
          prop="Gender"
          label="性别"
          show-overflow-tooltip
          width="160"
        ></el-table-column>

        <!-- <el-table-column label="操作" width="160">
          <template #default="scope">
            <el-button
              size="small"
              type="text"
              @click="onOpenUserList(scope.row)"
            >
              报名人员
            </el-button>
            <el-button
              size="small"
              type="text"
              @click="onOpenEditDic(scope.row)"
            >
              修改
            </el-button>
            <el-button size="small" type="text" @click="onRowDel(scope.row)">
              删除
            </el-button>
          </template>
        </el-table-column> -->
      </el-table>
      <el-pagination
        @size-change="onHandleSizeChange"
        @current-change="onHandleCurrentChange"
        class="mt15"
        :pager-count="5"
        :page-sizes="[10, 20, 30]"
        v-model:current-page="queryData.page"
        background
        v-model:page-size="queryData.pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
      >
      </el-pagination>
    </el-card>
    <!-- <dicDialog ref="dicDialogRef" @refresh="queryTableData()"></dicDialog> -->
  </div>
</template>

<script>
import { GetActivityInfoPage } from "@/api/talentActivity/talentActivityRegist";

export default {
  name: "activityRegistUsers",
  data() {
    return {
      loading: false,
      tableData: [],
      total: 0,
      queryData: {
        page: 1,
        pageSize: 10,
        SearchValue: "",
      },
    };
  },
  methods: {
    // onRowDel(row) {
    //   let that = this;
    //   this.$confirm("是否删除该数据？", "提示", {}).then(() => {
    //     that.HttpDelSysDic({ id: row.Id });
    //   });
    // },
    // onOpenAddDic(row) {
    //   this.$refs.dicDialogRef.openDialog(row, "add");
    // },
    // onOpenEditDic(row) {
    //   this.$refs.dicDialogRef.openDialog(row, "edit");
    // },
    queryTableData() {
      let param = {
        page: this.queryData.page,
        pageSize: this.queryData.pageSize,
        SearchValue: this.queryData.SearchValue,
      };
      this.HttpQueryBlogList(param);
    },
    onHandleSizeChange(val) {
      this.queryData.pageSize = val;
      this.queryTableData();
    },
    onHandleCurrentChange(val) {
      this.queryData.page = val;
      this.queryTableData();
    },
    //Http查询列表数据
    async HttpQueryBlogList(param) {
      this.loading = true;
      const res = await GetActivityInfoPage(param);
      this.loading = false;
      if (res.data.status == 200) {
        let raw = res.data.response;

        this.total = raw.dataCount;
        this.tableData = raw.data;
      } else {
        this.$message.error(res.data.msg);
        this.$message({
          message: res.data.msg,
          type: "error",
        });
      }
    },
    async HttpDelSysDic(param) {
      const response = await DeleteActivityTemple(param);
      let res = response.data || {};
      if (res.status == 200) {
        this.queryTableData();
        this.$message({
          message: "操作成功",
          type: "success",
        });
      } else {
        this.$message({
          message: res.msg,
          type: "error",
        });
      }
    },
    onOpenUserList(row) {},
  },

  mounted() {
    if (this.$route.query) {
      this.queryData.SearchValue = this.$route.query.name || "";
    }
    this.queryTableData();
  },
};
</script>

<style scoped></style>
